export const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="83.333">
    <path
      d="M10.586,13.262l8.333-8.333L60.586,46.6,18.919,88.262l-8.333-8.333L43.919,46.6Z"
      transform="translate(-10.586 -4.929)"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path
      d="M5.887,4.753A.8.8,0,0,0,4.753,5.887l4.631,4.631L4.753,15.149a.8.8,0,0,0,1.134,1.134l4.631-4.631,4.631,4.631a.8.8,0,0,0,1.134-1.134l-4.631-4.631,4.631-4.631a.8.8,0,0,0-1.134-1.134L10.518,9.384Z"
      transform="translate(-4.518 -4.518)"
    />
  </svg>
);

export const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM12,4a8,8,0,1,0,8,8A8,8,0,0,0,12,4Z" />
    <path d="M12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z" />
    <path d="M12,6a1,1,0,0,1-1-1V1a1,1,0,1,1,2,0V5A1,1,0,0,1,12,6Z" />
    <path d="M12,24a1,1,0,0,1-1-1V19a1,1,0,0,1,2,0v4A1,1,0,0,1,12,24Z" />
    <path d="M5,13H1a1,1,0,0,1,0-2H5a1,1,0,0,1,0,2Z" />
    <path d="M23,13H19a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z" />
  </svg>
);

export const MarkerIcon = ({ inlineStyles }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="63.526"
    height="79.355"
    viewBox="0 0 63.526 79.355"
    style={inlineStyles}
  >
    <path
      d="M31.763,76.807S10.281,56.713,2.354,36.5,21.162.514,31.763,1.488,68.7,12.986,60.75,36.5,31.763,76.807,31.763,76.807Z"
      fill="#b5a371"
    />
    <path
      d="M35.763,1C18.251,1,4,14.968,4,32.183c0,9.058,7.8,20.7,15.469,30.439A210.368,210.368,0,0,0,34.852,79.994a1.328,1.328,0,0,0,1.821,0A210.367,210.367,0,0,0,52.057,62.623c7.668-9.738,15.469-21.382,15.469-30.439C67.526,14.968,53.275,1,35.763,1Zm0,2.647c16.109,0,29.116,12.779,29.116,28.536,0,7.43-7.419,19.19-14.971,28.785A196.6,196.6,0,0,1,35.763,77.1a196.547,196.547,0,0,1-14.145-16.13c-7.552-9.6-14.971-21.355-14.971-28.785C6.647,16.426,19.654,3.647,35.763,3.647Zm0,5.294A21.175,21.175,0,1,0,56.938,30.116,21.2,21.2,0,0,0,35.763,8.941Zm0,2.647A18.528,18.528,0,1,1,17.235,30.116,18.508,18.508,0,0,1,35.763,11.588ZM22.528,19.528v2.647h3.391l3.97,16.376a3.921,3.921,0,0,0-2.149,3.475,3.97,3.97,0,0,0,7.941,0,4.09,4.09,0,0,0-.249-1.323H38.41a4.049,4.049,0,0,0-.167,1.323A3.992,3.992,0,0,0,42.213,46a3.975,3.975,0,0,0,.167-7.941H32.454l-.662-2.647H44.2a1.323,1.323,0,0,0,1.323-.911l3.393-10.588a1.325,1.325,0,0,0-.844-1.67,1.342,1.342,0,0,0-.4-.066H28.648l-.413-1.654a1.323,1.323,0,0,0-1.157-.993h-4.55Zm6.781,5.294H45.853l-.826,2.647H36.755v2.647h7.361l-.826,2.647H31.213ZM31.71,40.7a1.323,1.323,0,1,1-1.323,1.323A1.306,1.306,0,0,1,31.71,40.7Zm10.5,0a1.326,1.326,0,0,1,0,2.647,1.323,1.323,0,0,1,0-2.647Z"
      transform="translate(-4 -1)"
      fill="#fff"
    />
  </svg>
);

export const PinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="22"
    viewBox="0 0 18 22"
  >
    <path
      d="M9,0A9,9,0,0,0,0,9c0,7,9,13,9,13s9-6,9-13A9,9,0,0,0,9,0M9,12a3,3,0,1,1,3-3,3,3,0,0,1-3,3"
      fill="var(--gold-2)"
    />
  </svg>
);

export const MoreRounded = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
  >
    <path
      d="M19.5,2A17.5,17.5,0,1,0,37,19.5,17.5,17.5,0,0,0,19.5,2ZM12,22a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,12,22Zm7.5,0A2.5,2.5,0,1,1,22,19.5,2.5,2.5,0,0,1,19.5,22ZM27,22a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,27,22Z"
      transform="translate(-2 -2)"
      fill="#011027"
    />
  </svg>
);

export const CheckMark = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="11.25"
    viewBox="0 0 15 11.25"
  >
    <path
      d="M11.968,15.257l-3.75-3.75L6.343,13.382l5.625,5.625,9.375-9.375L19.468,7.757Z"
      transform="translate(-6.343 -7.757)"
      fill="#fff"
    />
  </svg>
);
